import { AxiosInstance } from "axios";
import { ApiRouteHelpers as Helpers } from "../../../root/apiRoutes";
import { OrganizationPublicId } from "../Types";
import { TrueScanResultsDto, UpdateTrueScanTrackerRequest } from "../dto/TrueScanResultsDto";

export class TrueScanController {
  constructor(private axios: AxiosInstance) {}

  public getLatestTrueScanResults = async (
    organizationId: OrganizationPublicId,
    rebake: boolean = false,
  ): Promise<TrueScanResultsDto> => {
    const getUrl = Helpers.organization.trueScan.root(organizationId, rebake);
    const response = await this.axios.get<TrueScanResultsDto>(getUrl);
    return response.data;
  };

  public runTrueScan = async (
    organizationId: OrganizationPublicId,
    scanUrl: string,
  ): Promise<{ success: boolean }> => {
    const postUrl = Helpers.organization.trueScan.scan(organizationId);
    const response = await this.axios.post<{ success: boolean }>(postUrl, { websiteUrl: scanUrl });
    return response.data;
  };

  public runOnboardingVendorScan = async (
    organizationId: OrganizationPublicId,
    scanUrl: string,
  ): Promise<{ started: boolean }> => {
    const postUrl = Helpers.organization.trueScan.onboardingVendorScan(organizationId);
    const response = await this.axios.post<{ started: boolean }>(postUrl, { websiteUrl: scanUrl });
    return response.data;
  };

  public hasEverScanned = async (
    organizationId: OrganizationPublicId,
  ): Promise<{ hasEverScanned: boolean; inProgress: boolean }> => {
    const url = Helpers.organization.trueScan.hasEverScanned(organizationId);
    const response = await this.axios.get<{ hasEverScanned: boolean; inProgress: boolean }>(url);
    return response.data;
  };

  public updateTracker = async (
    organizationId: OrganizationPublicId,
    trackerId: string,
    update: UpdateTrueScanTrackerRequest,
  ): Promise<{ success: boolean }> => {
    const url = Helpers.organization.trueScan.tracker(organizationId, trackerId);
    const response = await this.axios.post<{ success: boolean }>(url, update);
    return response.data;
  };

  public updateTrackersInBulk = async (
    organizationId: OrganizationPublicId,
    updates: Array<{ trackerId: string; update: UpdateTrueScanTrackerRequest }>,
  ): Promise<{ success: boolean }> => {
    const url = Helpers.organization.trueScan.trackerBulkUpdate(organizationId);
    const response = await this.axios.post<{ success: boolean }>(url, { updates });
    return response.data;
  };

  public downloadCsv = async (
    organizationId: OrganizationPublicId,
    rebake: boolean = false,
  ): Promise<Blob> => {
    const url = Helpers.organization.trueScan.csv(organizationId, rebake);
    const response = await this.axios.get(url, {
      responseType: "blob",
    });
    return response.data;
  };
}
